module.exports = __webpack_public_path__ + "static/media/Sport.Tv_Portogallo.ea92960c.png";